/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import PropTypes from 'prop-types';
import React from 'react';
import { Badge, Card, Spinner } from 'react-bootstrap';
import { faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QUESTION_FILTER_TYPE } from '../../../../constants/common';
import './styles.css';

const getFilterOptions = (filter) => {
  const options = filter.options || [];
  const optionList = options[0]?.options ? options[0].options : options;
  return optionList.filter(
    (option) => Number(option.code) >= 0 || Number.isNaN(Number(option.code))
  );
};

// The expanded row of the filter being edited mirrors the editor's live tag
// state: saved-or-unsaved reorders and renames apply, hidden tags drop out.
const getLiveTagOptions = (selectedFilterTags) => {
  const { tags, tagIdOrders, hiddenTags } = selectedFilterTags;
  const tagMap = {};
  tags.forEach((tag) => {
    tagMap[tag.id] = tag.value;
  });
  return tagIdOrders
    .filter((id) => hiddenTags.indexOf(String(id)) < 0 && tagMap[id] !== undefined)
    .map((id) => ({ code: id, description: tagMap[id] }));
};

const OtherFilters = ({
  filters,
  busy,
  selectedFilterCode,
  selectedFilterTags,
  onSelectFilter,
}) => {
  const attributeFilters = (filters || []).filter(
    (filter) => filter.type === QUESTION_FILTER_TYPE.ATTRIBUTE
  );

  return (
    <>
      {busy && (
        <div className="loading-container">
          <div className="content">
            <Spinner animation="border" role="status" />
            Updating preview with your changes
          </div>
        </div>
      )}
      {/* While busy the card is hidden with CSS, NOT unmounted, matching the
          SectionQuestions save/refresh behavior. */}
      <Card className={`survey-info-card bg-gray${busy ? ' d-none' : ''}`}>
        <Card.Header className="survey-info-card-header">Other Filters</Card.Header>
        {attributeFilters.length === 0 && (
          <div className="p-4 text-center">
            <b>This survey does not contain any other filters.</b>
          </div>
        )}
        {attributeFilters.map((filter) => {
          const isOpen = filter.code === selectedFilterCode;
          return (
            <Card key={filter.code} className="survey-info-card other-filter-row m-3">
              <div
                className="other-filter-row-header cursor-pointer"
                role="button"
                tabIndex={0}
                onClick={() => onSelectFilter(filter)}
              >
                <h4 className="other-filter-question mb-0">{filter.label || filter.description}</h4>
                <span className="d-flex align-items-center">
                  <Badge pill variant="dark" className="mr-3 text-uppercase">
                    {filter.type}
                  </Badge>
                  <FontAwesomeIcon size="lg" icon={isOpen ? faSortUp : faSortDown} />
                </span>
              </div>
              {isOpen && (
                <Card.Body className="other-filter-tags">
                  {(selectedFilterTags
                    ? getLiveTagOptions(selectedFilterTags)
                    : getFilterOptions(filter)
                  ).map((option) => (
                    <span key={option.code} className="other-filter-tag">
                      {option.description}
                    </span>
                  ))}
                </Card.Body>
              )}
            </Card>
          );
        })}
      </Card>
    </>
  );
};

OtherFilters.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.object),
  busy: PropTypes.bool,
  selectedFilterCode: PropTypes.string,
  selectedFilterTags: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.object),
    tagIdOrders: PropTypes.arrayOf(PropTypes.any),
    hiddenTags: PropTypes.arrayOf(PropTypes.any),
  }),
  onSelectFilter: PropTypes.func.isRequired,
};

OtherFilters.defaultProps = {
  filters: [],
  busy: false,
  selectedFilterCode: null,
  selectedFilterTags: null,
};

export default OtherFilters;
